import { ProjectId } from '/imports/domain';
import { projectHooks } from '/imports/modules/Project/presentation/hooks';
import { ProjectBrowser } from '/imports/modules/Project/presentation/ProjectBrowser';
import { end, lit, type, url, zero } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import { TopNavLayout } from '/imports/ui/layouts/TopNavLayout';

export const projectBrowserRoute = url(lit('project'), type('projectId', ProjectId), end);

export const projectBrowserRouter = zero().alt(
  projectBrowserRoute.parser.map((props) => (
    <Authorise
      deny={['exam', 'lti']}
      layout={(children) => <TopNavLayout selected="none">{children}</TopNavLayout>}
    >
      <ProjectBrowser hooks={projectHooks} {...props} />
    </Authorise>
  )),
);
